window.onload = function() {
    console.log("Loaded");
}